import React, {useState} from 'react';
import { Input, Typography, Button, Spin } from 'antd';
import { connect } from 'react-redux';
import download from 'downloadjs/download';

import { setMainPageContent, setPostsContent, addPostField, deletePostField, cleanFields } from 'actions/templateGenerator';
import MainMenu from 'components/mainMenu';
import { toastError, toastWarning, toastSuccess } from 'utils/toastr';

import './index.scss';
import requestAPI from 'helpers/requestAPI';

const TemplateGenerator = ({templateGeneratorData, setMainPageContent, setPostsContent, addPostField, deletePostField, cleanFields}) => {
    const [isSpinning, setIsSpinning] = useState(false);
    const { TextArea } = Input;
    const { Title } = Typography;

    const onMainContentChange = (e) => {
        setMainPageContent(e.target.value);
    }

    const onPostChange = (e, index) => {
        setPostsContent(index, e.target.value);
    }

    const checkFields = () => {
        if (templateGeneratorData.mainPageContent.trim() && !templateGeneratorData.posts.some(post => post.trim() === '')) return true;
        return false;
    }

    const onCreateTemplateClick = async () => {
        if(!checkFields()) {
            toastWarning('Please fill in all fields');
            return;
        }
        setIsSpinning((prevState) => !prevState);
        const params = {
			routeParams: {
                route: 'content_maker'
            },
            method: 'POST',
            type: 'arraybuffer',
            data: {
                main_post: templateGeneratorData.mainPageContent,
                posts: templateGeneratorData.posts
            }
        };

        await requestAPI(params).then((response) => {
            var blob = new Blob([response.data],{type:response.headers['content-type']});
            download(blob, 'template.zip');
            toastSuccess('Success');
            cleanFields();
        }).catch(err => {
            toastError(err);
        })

        setIsSpinning((prevState) => !prevState);
    }

    return (
        <div>
            <MainMenu />
            <div className="template-generated__wrapper">
                <div className="template-generated__left">
                    <Title level={4}>Main page content</Title>
                    <TextArea value={templateGeneratorData.mainPageContent} onChange={onMainContentChange} placeholder="Enter content..." />
                    <div className="template-generated__buttons">
                        <Spin spinning={isSpinning}>
                            <Button type="primary" onClick={onCreateTemplateClick}>Create template</Button>
                        </Spin>
                    </div>
                </div>
                <div className="template-generated__right">
                    <Title level={4}>Posts content</Title>
                    {templateGeneratorData.posts.map((post, index) => {
                        return <TextArea key={index} value={post} placeholder={`Enter post ${index + 1}`} onChange={(e) => onPostChange(e, index)} />
                    })}
                    <div className="template-generated__buttons">
                        <Button type='primary' onClick={addPostField}>Add post</Button>
                        <Button type="danger" onClick={deletePostField}>Delete post</Button>
                    </div>
                </div>
            </div>
        </div>
    )
}

const mapStateToProps = (state) => {
	return {
		templateGeneratorData: state.templateGenerator
	};
};

const mapDispatchToProps = (dispatch) => ({
    setMainPageContent: (data) => dispatch(setMainPageContent(data)),
    setPostsContent: (key, data) => dispatch(setPostsContent(key, data)),
    addPostField: () => dispatch(addPostField()),
    deletePostField: () => dispatch(deletePostField()),
    cleanFields: () => dispatch(cleanFields())
});

export default connect(mapStateToProps, mapDispatchToProps)(TemplateGenerator);